// ----------------------------------------------------------------------------
// App configuration
// ----------------------------------------------------------------------------
// One Vue SPA serves two separate-looking sites, chosen by hostname:
//   - Finance   -> serviceburodewilde.nl      (routes: /, /financiele-coaching, ...)
//   - Spiritual -> adriaanshelendehanden.nl   (routes: /, /spirituele-coaching, ...)
//
// On a recognised production host the router only registers that site's routes,
// so an outside visitor can't reach (or link to) the other site. On any other
// host (localhost, 127.0.0.1 used by the prerenderer, staging) BOTH route trees
// are registered so dev and the build-time prerender can see every page.
// ----------------------------------------------------------------------------

export const FINANCE_HOSTS = [
    'serviceburodewilde.nl',
    'www.serviceburodewilde.nl'
];

export const SPIRITUAL_HOSTS = [
    'adriaanshelendehanden.nl',
    'www.adriaanshelendehanden.nl'
];

// Canonical spiritual home route inside the SPA.
export const SPIRITUAL_HOME_PATH = '/spiritueel';

function hostname() {
    return (typeof window !== 'undefined' && window.location && window.location.hostname) || '';
}

/** True when viewed on one of the spiritual production hostnames. */
export function isSpiritualHost() {
    return SPIRITUAL_HOSTS.includes(hostname());
}

/** True when viewed on one of the finance production hostnames. */
export function isFinanceHost() {
    return FINANCE_HOSTS.includes(hostname());
}

/** True on a recognised production domain (either site). */
export function isStrictHost() {
    return isSpiritualHost() || isFinanceHost();
}

// Per-site identity — used for the browser-tab title, the <meta description>,
// the header/footer logo text, and canonical / Open Graph URLs. Change freely.
export const SITE = {
    finance: {
        name: 'Serviceburo de Wilde',
        baseUrl: 'https://serviceburodewilde.nl',
        description: 'Financiële coaching in Delft — persoonlijke begeleiding met overzicht, rust en richting.',
        // Used for link previews (Open Graph). Swap for a real 1200×630 image when you have one.
        image: '/favicon-finance-192.png'
    },
    spiritual: {
        name: 'Adriaans Helende Handen',
        baseUrl: 'https://adriaanshelendehanden.nl',
        description: 'Spirituele coaching en energiewerk — ruimte, verbinding en rust, in jouw tempo.',
        image: '/favicon-spiritual-192.png'
    }
};

export default {
    FINANCE_HOSTS,
    SPIRITUAL_HOSTS,
    SPIRITUAL_HOME_PATH,
    isSpiritualHost,
    isFinanceHost,
    isStrictHost,
    SITE
};
